import ApiService from "../service";

import { tierDescriptionsUrl } from "./api";

class TierDescriptionService extends ApiService {
  listUrl = tierDescriptionsUrl;
}

export default TierDescriptionService;
